import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress benign ResizeObserver errors in development
// Chrome sometimes throws "ResizeObserver loop limit exceeded" or
// "ResizeObserver loop completed with undelivered notifications" during layout thrashing.
// These are non-fatal and can trigger the error overlay; we prevent-default them here.
if (typeof window !== 'undefined') {
  const resizeObserverErrRegex = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
  window.addEventListener('error', (e) => {
    if (resizeObserverErrRegex.test(e?.message || '')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    const message = e?.reason?.message || '';
    if (resizeObserverErrRegex.test(message)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });

  // Filter dev overlay by silencing these specific errors in console.error
  if (process.env.NODE_ENV !== 'production') {
    const origError = console.error;
    console.error = (...args) => {
      try {
        const first = args && args[0];
        const msg = typeof first === 'string' ? first : (first && first.message) || '';
        if (resizeObserverErrRegex.test(msg)) return; // swallow benign ResizeObserver error
      } catch (_) {}
      origError(...args);
    };
  }
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
